import { Component, Input, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AggregatedPlaylistDTO, API, DateTimeRangeDTO, ScreenFullDTO, SharedPlaylistDTO } from '../../services/api/api';
import { ErrorService } from '../../services/error.service';
import { SelectDetailsResult, SelectDetailsValue } from '../../services/gui/modal/modal.model';
import { ModalService } from '../../services/gui/modal/modal.service';
import { UtilService } from '../../services/util.service';
import { SbDateTimeRangeViewerComponent } from '../controls/sb-date-time-range-viewer/sb-date-time-range-viewer.component';
import { TagService } from '../../services/tag.service';
import { DiscussionService } from '../../services/discussion.service';
import { SbPlaylistPreviewComponent } from './sb-playlist-preview/sb-playlist-preview.component';
import { RoutingID } from '../../routes/sb-routing-enum';
import { NavigationService } from '@ngx-seatback/utils';
import { NgbCarousel } from '@ng-bootstrap/ng-bootstrap';
import { PermissionService } from '../../services/permission.service';

@Component({
  selector: 'sb-comp-playlist-view',
  templateUrl: './sb-playlist-view.component.html',
  styleUrls: ['./sb-playlist-view.component.scss'],
  standalone: false,
})
export class SbPlaylistViewComponent {
  @ViewChild('e') e: NgbCarousel;
  @Input() isInIntegratedContext: boolean;
  @Input() isInDeviceContext: boolean = false;
  @Input({ required: true }) aggregated: boolean;

  _sharedPlaylists: SharedPlaylistDTO[] | AggregatedPlaylistDTO[];
  @Input() set sharedPlaylists(val: SharedPlaylistDTO[] | AggregatedPlaylistDTO[]) {
    this._sharedPlaylists = val;
    this.currentPlaylist = '1';
    if (this.e) {
      this.e.select(this.currentPlaylist);
    }
  }

  get sharedPlaylists(): SharedPlaylistDTO[] | AggregatedPlaylistDTO[] {
    return this._sharedPlaylists;
  }

  displayMode: string;
  currentPlaylist: string;

  constructor(
    private api: API,
    private modal: ModalService,
    public errorHandler: ErrorService,
    public util: UtilService,
    public translate: TranslateService,
    public tagService: TagService,
    public discussionService: DiscussionService,
    private navService: NavigationService,
    public permissionService: PermissionService
  ) {
    this.currentPlaylist = '1';
    this.displayMode = 'SLOTS';
    this._sharedPlaylists = null;
    this.isInIntegratedContext = false;
  }

  setDisplayMode(pDisplayMode: string) {
    this.displayMode = pDisplayMode;
  }

  getDisplayModeClass(pDisplayMode: string): string {
    if (pDisplayMode === this.displayMode) {
      return 'btn-hover-primary--active';
    } else {
      return 'btn-hover-primary';
    }
  }

  showDateTimeRanges(ranges: DateTimeRangeDTO[]) {
    this.modal
      .showNavigationModal({
        entryComponent: { value: SbDateTimeRangeViewerComponent, data: { dateTimeRanges: ranges } },
        title: null,
        modalOptions: { size: 'lg' },
      })
      .then(() => {})
      .catch(() => {});
  }

  showScreensModal(screens: ScreenFullDTO[]) {
    if (!this.isInDeviceContext) {
      const selectDetailsValues: SelectDetailsValue<number>[] = [];

      for (const screen of screens) {
        selectDetailsValues.push({
          name: this.translate.instant('lang.globals.device') + ' ' + screen.device.id,
          value: screen.device.id,
          description: this.translate.instant('lang.globals.screen') + ' ' + screen.id,
        });
      }

      this.modal
        .selectWithDetails({
          values: selectDetailsValues,
          initialValue: null,
          yes: this.translate.instant('lang.globals.showDevice'),
          no: this.translate.instant('lang.globals.cancel'),
          message: '',
          title: 'Screens',
          modalOptions: { size: 'xl' },
        })
        .then((e: SelectDetailsResult<number>) => {
          if (e?.value) {
            this.navService.navigateToPoint(
              RoutingID.deviceDetailsOverview,
              [
                {
                  id: 'deviceID',
                  value: e.value.value,
                },
              ],
              { target: '_blank' }
            );
          }
        });
    }
  }

  showPreview(selectedPlaylistString: string) {
    const playlistIndex: number = +selectedPlaylistString - 1;
    const selectedPlaylist: SharedPlaylistDTO | AggregatedPlaylistDTO = this._sharedPlaylists[playlistIndex];

    this.modal
      .showNavigationModal({
        entryComponent: { value: SbPlaylistPreviewComponent, data: { playlist: selectedPlaylist } },
        title: this.translate.instant('lang.globals.preview'),
        modalOptions: { size: 'lg' },
      })
      .then(result => {
        if (result) {
          // playbackSlot = result as PlaybackScheduleSlotDTO;
        }
      })
      .catch(() => {});
  }

  checkDisabled(currentPlaylist: string) {
    const playlistIndex: number = +currentPlaylist - 1;
    return (
      !this._sharedPlaylists[playlistIndex]?.playlist?.iterations ||
      this._sharedPlaylists[playlistIndex]?.playlist?.iterations?.length === 0
    );
  }
}
